import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import FormProvider, {
  RHFRadioGroup,
  RHFSelect,
  RHFTextField,
} from "src/components/hook-form";
import AssessmentController from "src/controller/Assessment.controller";
import { useProgram } from "src/hooks/useProgram";
import * as Yup from "yup";

// ----------------------------------------------------------------------

AddAssessment.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  courses: PropTypes.array,
};

export default function AddAssessment({
  open,
  onClose,
  courses,
  selectedProgram,
}) {
  const { id } = useParams();

  const [loadingSend, setLoadingSend] = useState(false);

  const uniqueCourses = [...new Set(courses)];

  const AddAssessmentSchema = Yup.object().shape({
    subject_code: Yup.string().required("Please select a Program"),
    student_id: Yup.string().required(),
    title: Yup.string().required("Assessment Name is required"),
    group: Yup.string().required("Please select an assessment group"),
  });

  const defaultValues = {
    subject_code: selectedProgram || "",
    student_id: id,
    title: "",
    group: "",
  };

  const methods = useForm({
    resolver: yupResolver(AddAssessmentSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = methods;

  const { program, handleProgramChange } = useProgram(id, reset);

  useEffect(() => {
    setValue("subject_code", program);
  }, [program, setValue]);

  const onSubmit = async (data) => {
    setLoadingSend(true);
    AssessmentController.create(data)
      .then((res) => {
        window.Toast("Assessment created successfully");
        handleClosePopUp();
      })
      .catch((err) => {
        console.error(`Api Error: ${err.message}`);
        window.ToastError(err.message);
        setLoadingSend(false);
      });
  };

  const handleClosePopUp = () => {
    reset(defaultValues);
    setLoadingSend(false);
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClosePopUp}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Add Assessment</DialogTitle>
        <DialogContent>
          <Divider />
          <Stack spacing={2} paddingTop={2}>
            <RHFSelect
              size="small"
              name="subject_code"
              label="Program Name"
              value={program}
              onChange={(event) => handleProgramChange(event.target.value)}
            >
              {uniqueCourses?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFTextField size="small" name="title" label="Assessment Name" />

            <Stack sx={{ mt: 4 }}>
              <RHFRadioGroup
                row
                spacing={3}
                name="group"
                label=""
                options={[
                  { value: "initial_assessment", label: "Initial Assessment" },
                  { value: "end_of_topic", label: "End Of Topic" },
                  { value: "program_check", label: "Progress Check" },
                  { value: "post_assessment", label: "Post Assessment" },
                ]}
              />
            </Stack>
          </Stack>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={loadingSend}
          >
            Add
          </LoadingButton>

          <Button color="error" variant="contained" onClick={handleClosePopUp}>
            Cancel
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
